<script lang="ts">
  /**
   * AudioFallback - Visual display when audio is unavailable
   * Shows letter/word in large text as a fallback
   */

  import { fade, scale } from 'svelte/transition';
  import { cubicOut } from 'svelte/easing';

  // Props
  interface Props {
    text: string;
    visible?: boolean;
  }

  let { text, visible = false }: Props = $props();
</script>

{#if visible}
  <div
    class="audio-fallback"
    transition:fade={{ duration: 300 }}
  >
    <div
      class="fallback-text"
      transition:scale={{ duration: 400, easing: cubicOut }}
    >
      {text}
    </div>
  </div>
{/if}

<style>
  .audio-fallback {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 200;
    pointer-events: none;
  }

  .fallback-text {
    font-size: 72px;
    font-weight: bold;
    color: var(--color-bright-yellow);
    text-shadow:
      0 0 20px rgba(252, 211, 77, 0.8),
      0 4px 12px rgba(0, 0, 0, 0.8);
    text-align: center;
    padding: var(--space-xl);
    background: rgba(10, 22, 40, 0.9);
    border-radius: var(--radius-lg);
    border: 3px solid var(--color-bright-yellow);
    animation: pulse 1s ease-in-out;
  }

  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
  }

  /* Responsive */
  @media (max-width: 767px) {
    .fallback-text {
      font-size: 48px;
      padding: var(--space-lg);
    }
  }
</style>
